(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reflexa-bundle-builder"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-rxb]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      let count = 2;
      let bundleActive = true;
      const offers = [...root.querySelectorAll('[data-count]')];
      const rows = [...root.querySelectorAll('[data-row]')];

      // Pohlaví není volba jednoho produktu, ale samostatné produkty. Velikosti
      // i fotku proto bereme z toho produktu, který je ve slotu zvolený —
      // jinak by se do košíku vždycky dostala varianta aktuální stránky.
      const handles = new Map((root.dataset.rxbGenders || '').split(',')
        .map((dvojice) => dvojice.split(':'))
        .filter((dvojice) => dvojice.length === 2)
        .map(([popis, handle]) => [popis.trim(), handle.trim()]));
      const produkty = new Map();
      const nactiProdukt = async (popis) => {
        if (produkty.has(popis)) return produkty.get(popis);
        const handle = handles.get(popis);
        if (!handle) return null;
        const slib = fetch(`/products/${handle}.js`)
          .then((odpoved) => (odpoved.ok ? odpoved.json() : null))
          .catch(() => null);
        produkty.set(popis, slib);
        return slib;
      };
      const naplnSlot = async (row) => {
        const gender = row.querySelector('[data-gender]');
        const size = row.querySelector('[data-size]');
        const image = row.querySelector('[data-rxb-image]');
        if (!gender || !size) return;
        const produkt = await nactiProdukt(gender.value);
        if (!produkt) {
          size.innerHTML = '<option value="">bald verfügbar</option>';
          return;
        }
        size.innerHTML = produkt.variants
          .map((varianta) => `<option value="${varianta.id}"${varianta.available ? '' : ' disabled'}>${varianta.title}</option>`)
          .join('');
        if (image && produkt.featured_image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = produkt.featured_image;
          image.alt = `${gender.value}jacke für Bundle-Auswahl`;
        }
      };
      rows.forEach((row) => {
        const gender = row.querySelector('[data-gender]');
        if (!gender) return;
        gender.addEventListener('change', () => naplnSlot(row));
        naplnSlot(row);
      });

      rows.forEach((row) => {
        const remove = row.querySelector('[data-rxb-remove]');
        if (!remove) return;
        remove.addEventListener('click', () => {
          row.classList.add('is-removed');
          const remaining = rows.filter((item) => !item.classList.contains('is-hidden') && !item.classList.contains('is-removed'));
          count = remaining.length;
          if (count === 0) {
            bundleActive = false;
            root.classList.add('is-single-mode');
            offers.forEach((offer) => {
              offer.classList.remove('is-active');
              offer.setAttribute('aria-checked', 'false');
            });
          }
        });
      });

      // Křížek na odebrání nemá smysl, když zbývá jediný řádek.
      const prekresliKrizky = () => {
        const aktivni = rows.filter((r) => !r.classList.contains('is-hidden') && !r.classList.contains('is-removed'));
        rows.forEach((r) => {
          const x = r.querySelector('[data-rxb-remove]');
          if (x) x.hidden = aktivni.length <= 1;
        });
      };
      rows.forEach((row) => {
        const remove = row.querySelector('[data-rxb-remove]');
        if (remove) remove.addEventListener('click', () => setTimeout(prekresliKrizky, 0));
      });
      prekresliKrizky();
      offers.forEach((offer) => offer.addEventListener('click', () => {
        bundleActive = true;
        root.classList.remove('is-single-mode');
        count = Number(offer.dataset.count);
        offers.forEach((item) => {
          const active = item === offer;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        rows.forEach((row, index) => {
          row.classList.remove('is-removed');
          row.classList.toggle('is-hidden', index >= count);
        });
        prekresliKrizky();
      }));

      // Tabulka velikostí (Kiwi) se v každém řádku řídí produktem, který je
      // v něm zvolený: na pánské stránce s dámskou ve druhém řádku se otevře
      // dámská tabulka. Kiwi má jeden sdílený modál; před otevřením ho necháme
      // překreslit daty zvoleného produktu přes loadIndividualKiwiSizingChart.
      const kiwiDostupne = () => typeof window.loadIndividualKiwiSizingChart === 'function' && window.KiwiSizing;
      const puvodniKiwi = () => document.querySelector('.product-block[data-dynamic-variants-enabled] ._ks_text');
      const otevriTabulkuPro = async (popis) => {
        const produkt = await nactiProdukt(popis);
        if (!produkt || !kiwiDostupne()) return;
        const z = window.KiwiSizing.data || {};
        if (String(produkt.id) === String(z.product) && puvodniKiwi()) { puvodniKiwi().click(); return; }
        const data = {
          shop: window.KiwiSizing.shop, product: String(produkt.id), title: produkt.title || '',
          tags: (produkt.tags || []).join(','), collections: z.collections || '',
          vendor: produkt.vendor || '', type: produkt.type || '', shopCurrency: z.shopCurrency || 'EUR', metafields: [],
        };
        const pred = new Set(document.querySelectorAll('._ks_text'));
        window.loadIndividualKiwiSizingChart(null, data, {}, (ok) => {
          if (!ok) return;
          window.setTimeout(() => {
            const novy = [...document.querySelectorAll('._ks_text')].find((k) => !pred.has(k) && !k.closest('[data-rxb]'));
            if (!novy) return;
            novy.click();
            // vložený odkaz už nepotřebujeme, jinak by se hromadily
            const obal = novy.closest('[class^="ks-"], [class*=" ks-"]') || novy;
            window.setTimeout(() => obal.remove(), 300);
          }, 250);
        });
      };
      const zapniTabulky = () => {
        rows.forEach((row) => {
          const slot = row.querySelector('[data-rxb-kiwi-slot]');
          const gender = row.querySelector('[data-gender]');
          if (!slot || !gender || slot.querySelector('.rxb__kiwi-link')) return;
          const odkaz = document.createElement('span');
          odkaz.className = '_ks_text rxb__kiwi-link';
          odkaz.textContent = (puvodniKiwi() && puvodniKiwi().textContent.trim()) || 'Größentabelle';
          odkaz.setAttribute('role', 'button');
          odkaz.setAttribute('tabindex', '0');
          odkaz.addEventListener('click', () => otevriTabulkuPro(gender.value));
          odkaz.addEventListener('keydown', (u) => { if (u.key === 'Enter' || u.key === ' ') { u.preventDefault(); otevriTabulkuPro(gender.value); } });
          slot.appendChild(odkaz);
        });
      };
      if (kiwiDostupne() && puvodniKiwi()) zapniTabulky();
      else {
        let pokusy = 0;
        const t = setInterval(() => { pokusy += 1; if ((kiwiDostupne() && puvodniKiwi()) || pokusy > 80) { clearInterval(t); if (kiwiDostupne()) zapniTabulky(); } }, 100);
      }

      const productArea = root.closest('[data-product-blocks]') || root.parentElement;
      const form = productArea && productArea.querySelector('form[action*="/cart/add"]');
      if (!form || form.dataset.rxbBound) return;
      form.dataset.rxbBound = 'true';
      form.addEventListener('submit', async (event) => {
        if (!bundleActive) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const button = form.querySelector('[type="submit"]');
        const error = root.querySelector('[data-rxb-error]');
        error.hidden = true;
        const activeRows = rows.filter((row) => !row.classList.contains('is-hidden') && !row.classList.contains('is-removed'));
        if (activeRows.length < 1) {
          error.textContent = 'Bitte wähle mindestens eine Jacke aus.';
          error.hidden = false;
          return;
        }
        if (button) button.disabled = true;
        try {
          const items = activeRows.map((row) => ({
            id: Number(row.querySelector('[data-size]').value),
            quantity: 1,
            properties: {
              Geschlecht: row.querySelector('[data-gender]').value,
              Bundle: activeRows.length === 1 ? '1 Jacke' : `${activeRows.length} Jacken`
            }
          }));
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Das Bundle konnte nicht hinzugefügt werden.');
          // Sleva jde přes automatické množstevní slevy, slevový kód v adrese
          // by se dal zneužít na celý košík. Zůstáváme na produktu a otevřeme
          // boční košík — téma neposlouchá vlastní události, jde jen přes spoušť.
          document.dispatchEvent(new CustomEvent('cart:build'));
          const spoust = document.querySelector('.js-drawer-open-cart');
          if (spoust) spoust.click();
          else if (window.theme && theme.CartDrawer && theme.CartDrawer.open) theme.CartDrawer.open();
          if (button) button.disabled = false;
        } catch (problem) {
          error.textContent = problem.message;
          error.hidden = false;
          if (button) button.disabled = false;
        }
      }, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
